module.exports = __webpack_public_path__ + "common/icon-arrow-white-2e724a112b3a68e6e621acabd5371bf1.svg";